import { generatePlainText } from 'src/app/project/components/input/rich-text/generate-plain-text';
import { safelyParseJSON } from 'src/app/project/components/input/rich-text/safely-parse-json';
import { TPointCustomFieldSumResponse } from 'src/app/project/modules/points/points-custom-fields-sum/points-custom-fields-sum.const';

export function formatPartialSumValue(
  partialSums: TPointCustomFieldSumResponse['partialSums'],
): TPointCustomFieldSumResponse['partialSums'] {
  const transformedSums = [];

  for (const partialSum of partialSums) {
    const formattedGroupBy = Object.fromEntries(
      Object.entries(partialSum.groupBy).map(([key, value]) => [
        key.toLowerCase(),
        generatePlainText(safelyParseJSON(value)) !== ''
          ? `${generatePlainText(safelyParseJSON(value))}`
          : value,
      ]),
    );

    transformedSums.push({
      ...partialSum,
      groupBy: formattedGroupBy,
    });
  }

  return transformedSums;
}
